module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-anton-46924-small-429d822acca7e84cae564254189fdea4.jpg";